module.exports = __webpack_public_path__ + "img/ka4-1.d9508522.png";